module.exports = __webpack_public_path__ + "static/img/audit-footer-logo.319188c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/audit-footer-logo.png
// module id = sOl2
// module chunks = 1